import type {
    LngLat,
    GenericGeometry,
    YMapMarker,
} from '@yandex/ymaps3-types'

import type { ClusterFeature, CreateClusterOptions } from './map-cluster.types'

import { CustomClusterer } from './custom-classes/custom-clusterer'
import { clusterByGrid } from './custom-classes/custom-cluster-by-grid'

import mapObjects from './map-objects'

function toCluster(coordinates: LngLat, element: HTMLElement): YMapMarker {
    return mapObjects.createMarker({ coordinates }, element)
}

function toMarker<T>(feature: ClusterFeature<T>, element: HTMLElement): YMapMarker {
    return mapObjects.createMarker({
        coordinates: (feature.geometry as GenericGeometry<LngLat>).coordinates as LngLat
    }, element)
}

export async function createCluster<T>(options: CreateClusterOptions<T>): Promise<any> {
    const clusterer = CustomClusterer<T>({
        method: clusterByGrid({ gridSize: options.gridSize }),
        features: options.features,
        marker: (feature: ClusterFeature<T>) => toMarker<T>(feature, options.markerTemplate(feature)),
        cluster: (coordinates: LngLat, features: Array<ClusterFeature<T>>) => toCluster(coordinates, options.clusterTemplate(features)),
        clusterPopup: options.clusterPopup,
        markerPopup: options.markerPopup
    })

    return clusterer
}

export default {
    createCluster
}